export function getAnomalyReportFileName (anomaly) {
  const reportId = String(anomaly?.anomaly_report_id ?? '').trim()

  if (!reportId) return null

  return `${reportId.replace('/', '_')}.pdf`
}
